import { PowerFull } from "./../../Public/assets";
import React from "react";

function SavingThirdSection() {
  return (
    <div className="hidden md:block bg-BankingExperience py-[50px] md:py-[48px] px-6 md:px-18 xxl:px-[134px] bg-gradientSavings">
      <h1 className=" m-auto sm:w-[80%] xl:w-1/2   font-IvyJournal font-semibold text-[22px]  sm:text-[33px] leading-[27.85px]  sm:leading-[36px] md:text-[44px] lg:text-[52px] md:leading-[44px] lg:leading-[65.83px] text-center xxl:px-[157px]">
        A powerful global banking experience
      </h1>
      <div className=" w-full flex justify-center items-center">
        <img
          src={PowerFull}
          alt="main-image"
          className=""
          // w-[295px] h-[147.45px] md:w-[1032.98px] md:h-[514.9px]
        />
      </div>
    </div>
  );
}

export default SavingThirdSection;
